import { Outlet } from 'react-router-dom';

export const FullPageLayout = () => {
  return (
    <div className="flex w-full min-h-screen">
      <div className="flex flex-col w-full h-full">
        <Outlet />
      </div>
    </div>
  );
};
